import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const PostStoreUsers = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/store/' + storeId + '/store-user', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandStore = (brandId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/store', // for android use
    headers: getHeaders(),
  });
};

export const getBrandUsers = (brandId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/brand/api/secure/v1/brand/' + brandId + '/user', // for android use
    headers: getHeaders(),
  });
};

export const postBrandUser = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/brand/api/secure/v1/brand/' + brandId + '/user', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putBrandUser = (brandId, data) => {
  return axios({
    method: 'put',
    url: STORE_BASE_URL + '/brand/api/secure/v1/brand/' + brandId + '/user', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const postBrandStore = (brandId,data) => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/store', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const putBrandStore = (brandId, data) => {
  return axios({
    method: 'put',
    url: STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/store', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getBrandStoreById = (storeId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/store/' + storeId, // for android use
    headers: getHeaders(),
  });
};



export const getStoreUsersStoreConfig = (brandId, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand/' +
      brandId +
      '/store-user/' +
      storeId, // for android use
    headers: getHeaders()
  });
};

export const postStoreUsersStoreConfig = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/store-user',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putStoreUsersStoreConfig = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/store-user',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandRole = (brandId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/brand/api/v1/brand/' +
      brandId +
      '/role',
    headers: getHeaders()
  });
};


export const addBrandStorePolygon = (data) => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/store-polygon',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBrandStorePolygon = (data) => {
  return axios({
    method: 'put',
    url: STORE_BASE_URL + '/store/api/secure/v1/store-polygon',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const searchStorePolygon = (data) => {
  return axios({
    method: 'post',
    url: STORE_BASE_URL + '/store/api/secure/v1/search-store-polygon',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandRiderDashboardByDays = (storeId, riderId, days) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/store/' + storeId + '/rider/' + riderId + '/dashboard/' + days, // for android use
    headers: getHeaders(),
  });
};


export const postSwitchStoreUsersStoreConfig = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/store/api/secure/v1/brand/' + brandId + '/switch-store-user',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};